import React, { useCallback, useEffect, useState } from 'react'
import CategoryList from '../../data/NFTCategoryList'
import INFTCategory from '../../models/INFTCategory'
import NFTCategoryButton from '../../components/NFTCategoryButton'
import { getSalesNFTList } from '../../../../services/NFTMarketPlace/Graphquery'
import Loader from '../../../../components/Loader'
import INFTSalesList from '../../models/INFTSalesList'
import { useActiveWeb3React } from '../../../../hooks'
import NFTMarketPlaceMenu from '../../components/NFTMarketPlaceMenu'
import NFTMarketItem from './components/NFTMarketItem'
import { MARKET_PLACE } from '../../data/NFTMarketPerPages'
import { CategoryListWrapper, PageWrapper, FilterListWrapper } from './styled'
import NFTCurrencyDropdown from '../../components/NFTCurrencyDropdown'
import NFTDropdown from '../../components/NFTDropdown'
import { NFTPerPage, NFTSortingList } from '../../data/NFTFilterOptions'
import NFTCollectionListDropdown from '../../components/NFTCollectionListDropdown'
import IPriceInfo from '../../models/IPriceInfo'
import { getTokenPrice } from '../../../../services/NFTMarketPlace/ApiCall'
import { INFTMarketProps } from '../../models/INFTMarket'
import { useHistory, useLocation } from 'react-router-dom'
import useBottomScroll from '../../../../hooks/useBottomScroll'
import NFTCard from '../../newComponents/NFTCard';
import NFTList from '../../newComponents/NFTList';
import { Helmet } from 'react-helmet'
import { loadNFTLikeCounts } from '../../data/useNFTLikeCount'

export default function NFTMarketPlace(props: INFTMarketProps) {
	const { account } = useActiveWeb3React()
	/*NFT SALES LIST START*/
	const [NFTListData, setNFTList] = useState<INFTSalesList[]>([])
	const [skipItems, setSkipItems] = useState<number>(0)
	const [hasMore, setHasMore] = useState<boolean>(false);

	const history = useHistory()
	const location = useLocation()

	const getSearchParams = new URLSearchParams(history.location.search)
	const categoryParam = getSearchParams.get('category')
	const collectionParam = getSearchParams.get('collection')
	const currencyParam = getSearchParams.get('currency')
	const sortParam = getSearchParams.get('sort')
	const perPageParam = getSearchParams.get('perPage')

	const categoryFilter = categoryParam === 'ALL' || !categoryParam ? '0' : parseInt(categoryParam)
	const currencyFilter = currencyParam ? currencyParam : 'ALL'
	const collectionFilter = collectionParam ? collectionParam : 'ALL'
	const sortFilter = sortParam ? sortParam : 'NewestItems'
	const perPageFilter = perPageParam ? parseInt(perPageParam) : MARKET_PLACE.HOME

	const [listLoading, setListLoading] = useState(true)
	const [priceInfo, setPriceInfo] = useState<IPriceInfo | null>(null)

	const categoryQuery = categoryFilter === '0' ? null : categoryFilter

	function createQueryString() {
		let queryString: any[] = []

		if (categoryFilter) {
			queryString.push(`category=${categoryFilter}`)
		}

		if (collectionFilter) {
			queryString.push(`collection=${collectionFilter}`)
		}

		if (currencyFilter) {
			queryString.push(`currency=${currencyFilter}`)
		}

		if (sortFilter) {
			queryString.push(`sort=${sortFilter}`)
		}

		if (perPageFilter) {
			queryString.push(`perPage=${perPageFilter}`)
		}

		return "?" + queryString.join('&');
	}

	const createdQueryString = createQueryString()

	if (!categoryFilter || !collectionParam || !currencyParam || !sortParam || !perPageParam) {
		history.replace(`/explore${createdQueryString}`)
	}

	const getSalesNFTItems = useCallback(() => {
		setListLoading(true)

		getSalesNFTList({
			collection: collectionFilter,
			categoryId: categoryQuery,
			sortItems: sortFilter,
			currency: currencyFilter,
			perPage: perPageFilter,
			skipItems: skipItems
		})
			.then((response: INFTSalesList[]) => {
				loadNFTLikeCounts(response.map((r: INFTSalesList) => ({ collectionAddress: r.tokenContract, tokenID: r.tokenId })));
				if (response) {
					if (skipItems === 0) {
						setNFTList(response)
					} else {
						setNFTList([...NFTListData, ...response])
					}
				}
				setListLoading(false)
				setHasMore(response.length === perPageFilter);
			})
			.catch((err: any) => {
				setListLoading(false)
			})
	}, [skipItems, currencyFilter, collectionFilter, sortFilter, perPageFilter, categoryQuery])

	useEffect(() => {
		getTokenPrice().then((res: any) => setPriceInfo(res))
	}, [])

	useEffect(() => {
		getSalesNFTItems()
	}, [location.search, skipItems])
	/*NFT SALES LIST END*/

	useBottomScroll(
		(isBottom: boolean) => {
			if (isBottom && skipItems > 0) {
				const newSkipItems = skipItems + perPageFilter
				setSkipItems(newSkipItems)
			}
		},
		'nft-list',
		{
			offset: 300
		}
	)

	function filterChange(param: number | string | null, key: string) {
		const splitSearch = history.location.search.replace('?', '').split('&')
		const newParam = (param === null || (key == "category" && param == 0)) ? 'ALL' : param

		const newSearchArray = splitSearch.map(searchParam => {
			let result = searchParam
			if (searchParam.includes(key)) {
				result = `${key}=${newParam}`
			}
			return result
		})

		history.push(`/explore?${newSearchArray.join('&')}`)
		setSkipItems(0)
	}

	function getList() {
		return NFTListData.map((item: INFTSalesList) => (
			<NFTMarketItem
				key={`${item.id}_${item.tokenContract}_MARKET`}
				item={item}
				getSalesNFTItems={getSalesNFTItems}
				account={account ? account : ''}
				priceInfo={priceInfo}
			/>
		))
	}

	return (
		<PageWrapper>
			<Helmet>
				<title>{"Explore - YetiSwap NFT Marketplace"}</title>
			</Helmet>
			<NFTList
				id="nft-list"
				onClickLoadMore={() => setSkipItems(skipItems + perPageFilter)}
				skipItems={skipItems}
				hasMore={hasMore}
				filterChange={filterChange}
				loading={listLoading}
				filterDefaultKeys={{
					"category": categoryFilter.toString(),
					"collection": collectionFilter,
					"currency": currencyFilter,
					"sort": sortFilter,
					"perPage": perPageFilter.toString()
				}}
			>
				{getList()}
			</NFTList>
		</PageWrapper>
	)
}
